module.exports = __webpack_public_path__ + "static/media/hot_limonene.7607cf03.png";